<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    },
    recommend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 50,
        total: 0
      },
      field: {
        value: 'id',
        label: 'name'
      },

      localRecommend: this.recommend
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
    },
    async loadData(keyword) {
      try {
        const { page, size } = this.page;
        const params = {
          ...this.queryParams,
          page,
          size,
          customerFlag: this.$enums.YES_OR_NO.YES.value,
          name: keyword
        };
        if (this.recommend) {
          params.recommend = this.localRecommend;
        }
        const res = await this.$store.dispatch('bu_customerProject/fetchOptions', params);
        let records = res.data.records || [];
        // 更新分页总数
        this.page.total = res.data.total;
        return {
          data: records
        };
      } catch (err) {
        console.error('加载客户数据失败:', err);
        throw err;
      }
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    onRecommendChange() {
      this.$refs.pulldown.onQuery(true)
    },
    async fetchObject(value) {
      return await this.$store.dispatch('bu_customerProject/fetchObject', value);
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="field"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template v-if="recommend" #search-append>
      <el-checkbox class="margin-left" v-model="localRecommend" @change="onRecommendChange">仅看推荐</el-checkbox>
    </template>
    <template #content="{ list }">
      <div v-for="(item, index) in list" :key="index" class="item padding-sm cursor" :class="{ 'active': item.id === localValue }" @click="$refs.pulldown.onItemChecked(item)">
        <div class="flex justify-between">
          <div>
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.name }}</span>
            <el-tag class="margin-left" v-if="item.parentId" type="warning">子</el-tag>
          </div>
        </div>
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
.item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
}
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
